import React from "react";

import {
  BrowserRouter as Router,
  Route,
  Switch,
  useParams
} from "react-router-dom";
import { useDispatch } from "react-redux";

import Dashboard from "../components/Layout/Dashboard";
import CalendarPage from "../components/Calendar/CalendarPage";
import DrillDownPieChart from "../components/Charts/PieChart/DrillDownPieChart";
import ParentGanttChart from "../components/Charts/PieChart/ParentGanttChart";
import ManagerDashboard from "../components/ManagerDashboard/ManagerDashboard";
import ManagerDashboardMultiParam from "../components/ManagerDashboard/ManagerDashboardMultiParam";
import Spc from "../components/Spc/Spc";
import GoldenTunnel from "../components/Spc/GoldenTunnel";

import EnergyReport from "../components/Reports/EnergyReport";

import SemiCircleParent from "../components/Charts/PieChart/SemiCircleParent";
import Assessment from "../components/Assessments/Assessment";

import STORM from "../components/STORM/QuizForm";
import QcRecordStorm from "../components/STORM/QcRecordStorm";
import OpObservShStorm from "../components/STORM/OpObservShStorm";
import QcRecordStormPrime from "../components/STORM/QcRecordStormPrime";
import StormPrime from "../components/STORM/StormPrime";

import ManpowerDeploymentStorm from "../components/STORM/ManpowerDeploymentStorm";

import QcReportStable from "../components/Qc/QcReportStable";
import QcReportStableMrpl from "../components/Qc/QcReportStableMrpl";



import ExamDetail from "../components/Exams/ExamDetail";

import CreateUpdateAuditPage from "../components/Audit/Create/CreateAndEditAuditPage";
import ListAudit from "../components/Audit/List/AuditListPage";
import ViewReportAudit from "../components/Audit/View/AuditViewReport";
import PageNotFound from "../components/Layout/Pages/404";

import TrainingEffective from "../pages/TrainingEffective";

import TrainingSession from "../pages/TrainingSession";
// import LineAttendance from "../pages/LineAttendance";
import CreateExamSession from "../pages/CreateExamSession";
import ScrollToTop from "../components/ScrollToTop/ScrollToTop";
import LineAccessDropDown from "../components/Access/LineAccessDropDown";
import VersionPage from "../pages/VersionPage";
import LinePerformancemob from "../pages/LinePerformancemob";
import UpdateCp1Ppm5sIapf from "../pages/UpdateCp1Ppm5sIapf";

// import ReportTom from "../pages/ReportTom";
import ReportTree from "../pages/ReportTree";
import FourMReportStableDir from "../pages/4M/FourMReportStableDir";
import LinePerformanceLineLeaders from "../pages/LinePerformanceLineLeaders";
import ImageView from "../components/ImageView/ImageView";

// import StableData from "../pages/DSeries/StableData";
import UploadFile from "../pages/UploadFile";
import UploadIMG from "../pages/UploadIMG";
import UploadPlan from "../pages/DSeries/UploadPlan";
import UploadSbScheduleVariation from "../pages/DSeries/UploadSbScheduleVariation";
import UploadLivoECN from "../pages/DSeries/UploadLivoECN";
import UploadEtBom from "../pages/DSeries/UploadEtBom"; //same as uploadlivoecn

import UploadBom from "../pages/DSeries/UploadBom";
import TrainingNeeds from "../pages/Training/TrainingNeeds";
import TrainingDojo from "../pages/Training/TrainingDojo";
import TrainingRecords from "../pages/Training/TrainingRecords";
import Charts from "../pages/Charts";
import PdfViewer from "../pages/PdfViewer";
import PasswordReset from "../pages/PasswordReset";
import Calendar_McPrevMaint from "../components/Calendar/Calendar_McPrevMaint";
import Calendar_ToolPrevMaint from "../components/Calendar/Calendar_ToolPrevMaint";
import Calendar_Calibration from "../components/Calendar/Calendar_Calibration";
import Calendar_Day from "../components/Calendar/Calendar_Day";
import CalenderTime from "../components/Calendar/TimeGridCalendar";


import ShiftSupervisorReport from "../pages/SkillPages/ShiftSupervisorReport";
// import StableChart from "../pages/DSeries/StableChart";


import StAddNew from "../pages/DSeries/StAddNew";
import PhantomPrime from "../pages/PhantomPrime";
// import PhantomGraph from "../pages/PhantomGraph";

// import LineDashTabSel from "../components/LineDashboardV/LineDashTabSel";
import liracrypt from "../components/Liracrypt/liracrypt";
import ApiErrorComp from "../components/ApiErrorComp/ApiErrorComp";
import LineDashboardZenMQ from "../pages/LineDashboardMQ";

import CreateBsl4m from "../pages/4M/CreateBsl4m";
import CreateMrpl4M from "../pages/4M/CreateMrpl4M";
import CreateGil4M from "../pages/4M/CreateGil4M";
import CreateGen4m from "../pages/4M/CreateGen4m";

import LineWorkInstructions from "../Livo/lineworkinstructions";
import TrendDataDynamic from "../components/ManagerDashboard/TrendDynamicDashboard";
import Pharos from "../components/ManagerDashboard/Pharos";
import CorporateDashboard from "../components/ManagerDashboard/CorporateDashboard";
// import ZenChartTemplate from "../components/ManagerDashboard/ZenChartArsenal";

// import ZenChartTemplateSnippet from "../components/ManagerDashboard/ZenChartTemplateSnippet";


// import ZenChartFunctions from "../components/ManagerDashboard/ZenChartComboFunction";
import ZenDualChartTemplate from "../components/ManagerDashboard/ZenDualChartTemplate";
import ManpowerCostDashboard from "../components/ManagerDashboard/ManpowerCostDashboard";
import ApqoDashboard from "../components/ManagerDashboard/ApqoDashboard";



import CostTemplate from "../components/ManagerDashboard/CostTemplate";

import TreeComponent from "../pages/TreeComponent";
import PhantreePrime from "../pages/PhantreePrime";
import FGKanBanBoard from "../pages/FGKanboard/FGKanboard";
import HeijunkaBoard from "../pages/HeijunkaBoard/HeijunkaBoard";
import allRoutes from "./latestRoutes";
import ImageUpload from "../pages/ImageUpload";

import ZenForm from "../pages/ZenForm";
import LineDashboardZen from "../pages/LineDashboardZen";
import RouteSlideShow from "../pages/RouteSlideShow";
import CreateNewGil4M from "../pages/4M/CreateNewGil4M";
import LineGroupDashboard from "../pages/LineGroupDashboard";
import DigitalTwin from "../pages/DigitalTwin";
import CreateGilSreaNew from "../pages/4M/CreateGilSreaNew";
import ProductionReport from "../pages/ProductionSlot";
import ZenFormBuilder from "../pages/ZenFormBuilder";
import DynamicZenChart from "../pages/DynamicZenChart";
import QueryBuilder from "../pages/QueryBuilder";
import StableBuilder from "../pages/StableBuilder";
import StablePreview from "../pages/StablePreview";
import CameraComponent from "../pages/Camera";
import DynamicZenChartCatalogue from "../pages/DynamicZenChartCatalogue";
import ChartBuilder from "../pages/ChartBuilder";
import ApiTest from "../pages/ApiTest";
import VideoPlayer from "../pages/VideoPlayer";
import ImageSlideShow from "../pages/ImageSlideShow";
import CreateTask from "../pages/PMS/CreateTask";
import CreateProject from "../pages/PMS/CreateProject";
import SparkTableBuilder from "../pages/SparkTableBuilder";
import RFIDModal from "../components/RFIDModal";
import ExamDetailZF from "../components/Exams/ExamDetailZF";
import FolderTree from "../components/FolderTree";
import VehicleTracker from "../pages/VehicleTracker";
import CreateGilSupplier4M from "../pages/4M/CreateGilSupplier4M";
import TaskCalendar from "../components/Calendar/TaskCalendar";
import NewPage from "../pages/NewPage";
import CorporatePlant from "../pages/CorporatePlant";
import ZenJSONEditor from "../pages/ZenJSONEditor";
import SignIn from "../components/SignIn/SignIn";
import ZenGanttChart2 from "../components/ManagerDashboard/Common/Graph/ZenGanttChart2";


function ModRouter() {
  const { urlCode } = useParams();
  const dispatch = useDispatch();

  const setPageHeader = (pageName = '') => {
    dispatch({
      type: 'pageName',
      payload: pageName
    })
  }

  function setPhantomData(key, value, version) {
    const now = new Date();

    const item = {
      value: value,
      version: version,
    };
    localStorage.setItem(key, JSON.stringify(item));
  }

  function getPhantomData(key, version) {
    const itemStr = localStorage.getItem(key);

    if (!itemStr) {
      return false;
    }
    const item = JSON.parse(itemStr);

    if (item["version"] !== version) {
      localStorage.removeItem(key);
      return true;
    }
    return false;
  }

  React.useEffect(() => {
    dispatch({
      type: 'urlCode',
      payload: urlCode
    });
    localStorage.setItem('urlCode', urlCode);
    // setInterval(() => {
    //   liracrypt
    //     .get("/mdict", { typ: "MDictVersionControl", subTyp: "listData" })
    //     .then((res, req) => {
    //       const List = res.data.data;
    //       List.forEach((data, index) => {
    //         data["activeTypes"].forEach((subTyp, i) => {
    //           let mDictName = data["typ"] + "_" + subTyp;
    //           if (getPhantomData(mDictName, data["ver"])) {
    //             liracrypt
    //               .get(data["url"], { typ: data["typ"], subTyp: subTyp })
    //               .then((res, req) => {
    //                 setPhantomData(
    //                   data["typ"] + "_" + subTyp,
    //                   res.data.data,
    //                   data["ver"]
    //                 );
    //               })
    //               .catch((err) => {
    //                 console.log("Error Extract Mdict - " + data["typ"]);
    //               });
    //           }
    //         });
    //       });
    //     })
    //     .catch((err) => {
    //       console.log(ApiErrorComp);
    //     });
    // }, 1200000);
  }, []);

  return (
    <>
      {window.location.pathname.includes("/image") ||
        window.location.pathname.includes("/pdf") ? (
        <>
          <Route
            exact
            path="/v02/:urlCode/image"
            component={() => <ImageView setPageHeader={setPageHeader} />}
          />
          <Route
            exact
            path="/v02/:urlCode/pdf"
            component={() => <PdfViewer setPageHeader={setPageHeader} />}
          />
        </>
      ) : (
        <Router>
          <Switch>
            <Route exact path="/v02/:urlCode/linedashboard" component={LineDashboardZen} />
            <Route exact path="/v02/:urlCode/linegroupdashboard" component={LineGroupDashboard} />
            <Route exact path="/v02/:urlCode/linedashboardmq" component={LineDashboardZenMQ} />
            <Route exact path="/v02/:urlCode/linedashboardzen" component={LineDashboardZen} />
            <Route exact path="/v02/:urlCode/sb/fg-kanban-board" component={FGKanBanBoard} />
            <Route exact path="/v02/:urlCode/sb/heijunka-board" component={HeijunkaBoard} />
            <Route exact path="/v02/:urlCode/digital-twin" component={DigitalTwin} />
            {/* <Route
              exact
              path="/v02/:urlCode/pharos/:typ/:subtyp"
              component={() => <Pharos setPageHeader={setPageHeader}
                urlEndpoint="/miscellaneous/pageconfig"
                dictName="FormatPharosTabs" />}
            /> */}
            {/* PMS ROUTES */}
            <Route exact path="/v02/:urlCode/pms/create-task" component={CreateTask} />
            <Route exact path="/v02/:urlCode/pms/create-project" component={CreateProject} />
            {/* PMS ROUTES */}
            {/* LIVO ROUTES HERE */}
            <Route
              exact
              path="/v02/:urlCode/lineworkinstruction"
              component={() => (
                <LineWorkInstructions
                  setPageHeader={setPageHeader}
                  pageName="Work Instruction"
                  urlEndpoint=""
                  urlData={{ dictName: "" }}
                />
              )}
            />

            <Route
              exact
              path="/v02/:urlCode/dashboard/trenddata"
              component={() => <TrendDataDynamic setPageHeader={setPageHeader} />}
            />

            <Route
              exact
              path="/v02/:urlCode/corp/corporatedashboard"
              component={() => (
                <CorporateDashboard setPageHeader={setPageHeader} />
              )}
            />

            <Route
              exact
              path="/v02/:urlCode/dashboard/manpowercost"
              component={() => <ManpowerCostDashboard setPageHeader={setPageHeader} />}
            />

            <Route
              exact
              path="/v02/:urlCode/dashboard/apqo"
              component={() => <ApqoDashboard setPageHeader={setPageHeader} />}
            />

            <Route
              exact
              path="/v02/:urlCode/template/costtemplate"
              component={() => <CostTemplate setPageHeader={setPageHeader} />}
            />
            <Route
              exact
              path="/v02/:urlCode/template/svr-gantt"
              component={() => <ZenGanttChart2 setPageHeader={setPageHeader} />}
            />

            {/* LIVO ROUTES HERE */}
            {/* <Route exact path="/linedashtab" component={LineDashTabSel} /> */}
            {/* <Route
              exact
              path="/v02/:urlCode/fulldashboard"
              component={() => (
                <div style={{ padding: "20px" }}>
                  <ManagerDashboard setPageHeader={setPageHeader} />
                </div>
              )}
            /> */}
            <Dashboard>
              <ScrollToTop>
                <Route
                  exact
                  path="/v02/:urlCode"
                  component={() => (
                    <ManagerDashboard setPageHeader={setPageHeader} />
                  )}
                />

                <Route
                  exact
                  path="/v02/:urlCode/img-upload"
                  component={() => (
                    <ImageUpload />
                  )}
                />
                <Route
                  exact
                  path="/v02/:urlCode/bsl/qcreportstable/:docNo"
                  component={() => (
                    <QcReportStable setPageHeader={setPageHeader} />
                  )}
                />
                <Route
                  exact
                  path="/v02/:urlCode/mrpl/qcreportstable/:docNo"
                  component={() => (
                    <QcReportStableMrpl setPageHeader={setPageHeader} />
                  )}
                />

                <Route
                  exact
                  path="/v02/:urlCode/bsl/fourmreportstable/:docNo"
                  component={() => (
                    <FourMReportStableDir setPageHeader={setPageHeader} />
                  )}
                />
                <Route
                  exact
                  path="/v02/:urlCode/bsl/createbsl4m"
                  component={() => <CreateBsl4m setPageHeader={setPageHeader} />}
                />
                <Route
                  exact
                  path="/v02/:urlCode/bsl/viewbsl4m"
                  component={() => <CreateBsl4m setPageHeader={setPageHeader} />}
                />
                <Route
                  exact
                  path="/v02/:urlCode/mrpl/viewbsl4m"
                  component={() => <CreateMrpl4M setPageHeader={setPageHeader} />}
                />
                <Route
                  exact
                  path="/v02/:urlCode/storm/:docNo"
                  component={() => <STORM setPageHeader={setPageHeader} />}
                />
                <Route
                  exact
                  path="/v02/:urlCode/mrpl/qcreportstorm"
                  component={() => (
                    <QcRecordStormPrime setPageHeader={setPageHeader} />
                  )}
                />

                <Route
                  exact
                  path="/v02/:urlCode/template/stormprime/:docNo"
                  component={() => (
                    <StormPrime setPageHeader={setPageHeader} />
                  )}
                />
                <Route
                  exact
                  path="/v02/:urlCode/bsl/qcreportstorm"
                  component={() => (
                    <QcRecordStorm setPageHeader={setPageHeader} />
                  )}
                />
                <Route
                  exact
                  path="/v02/:urlCode/bsl/opobservationsheetstorm/:docNo"
                  component={() => (
                    <OpObservShStorm setPageHeader={setPageHeader} />
                  )}
                />

                <Route
                  exact
                  path="/v02/:urlCode/bsl/qcreportstormprime/:docNo"
                  component={() => (
                    <QcRecordStormPrime setPageHeader={setPageHeader} />
                  )}
                />

                <Route
                  exact
                  path="/v02/:urlCode/bsl/manpowerdeploymentstorm/:docNo"
                  component={() => (
                    <ManpowerDeploymentStorm setPageHeader={setPageHeader} />
                  )}
                />
                <Route
                  exact
                  path="/v02/:urlCode/camera"
                  component={() => (
                    <CameraComponent setPageHeader={setPageHeader} />
                  )}
                />
                <Route
                  exact
                  path="/v02/:urlCode/shiftsupervisorreport"
                  component={() => (
                    <ShiftSupervisorReport setPageHeader={setPageHeader} />
                  )}
                />
                <Route
                  exact
                  path="/v02/:urlCode/training/Trainingsession"
                  component={() => (
                    <TrainingSession setPageHeader={setPageHeader} />
                  )}
                />
                <Route
                  exact
                  path="/v02/:urlCode/createexamsession"
                  component={() => (
                    <CreateExamSession setPageHeader={setPageHeader} />
                  )}
                />

                <Route
                  exact
                  path="/v02/:urlCode/trainingevaluation"
                  component={() => (
                    <TrainingEffective setPageHeader={setPageHeader} />
                  )}
                />
                <Route
                  exact
                  path="/v02/:urlCode/upload/skillmatrix/employee"
                  component={() => (
                    <UploadSbScheduleVariation setPageHeader={setPageHeader} />
                  )}
                />
                <Route
                  exact
                  path="/v02/:urlCode/etbom/upload"
                  component={() => (
                    <UploadEtBom setPageHeader={setPageHeader} />
                  )}
                />

                <Route
                  exact
                  path="/v02/:urlCode/upload/bom"
                  component={() => <UploadBom setPageHeader={setPageHeader} />}
                />
                <Route
                  exact
                  path="/v02/:urlCode/training/needs"
                  component={() => (
                    <TrainingNeeds setPageHeader={setPageHeader} />
                  )}
                />

                <Route
                  exact
                  path="/v02/:urlCode/training/dojo"
                  component={() => (
                    <TrainingDojo setPageHeader={setPageHeader} />
                  )}
                />

                <Route
                  exact
                  path="/v02/:urlCode/training/records"
                  component={() => (
                    <TrainingRecords setPageHeader={setPageHeader} />
                  )}
                />

                <Route
                  exact
                  path="/v02/:urlCode/update/ppm5siapf"
                  component={() => (
                    <UpdateCp1Ppm5sIapf setPageHeader={setPageHeader} />
                  )}
                />

                <Route
                  exact
                  path="/v02/:urlCode/exam"
                  component={() => <ExamDetail setPageHeader={setPageHeader} />}
                />
                <Route
                  exact
                  path="/v02/:urlCode/exam-zf"
                  component={() => <ExamDetailZF setPageHeader={setPageHeader} />}
                />
                <Route
                  exact
                  path="/v02/:urlCode/assessment"
                  component={() => <Assessment setPageHeader={setPageHeader} />}
                />

                <Route
                  exact
                  path="/v02/:urlCode/uploadimage"
                  component={() => <UploadIMG setPageHeader={setPageHeader} />}
                />
                <Route
                  exact
                  path="/v02/:urlCode/toolmaintenance/pmcalendar"
                  component={() => (
                    <Calendar_ToolPrevMaint setPageHeader={setPageHeader} />
                  )}
                />
                <Route
                  exact
                  path="/v02/:urlCode/mcmaintenance/pmcalendar"
                  component={() => (
                    <Calendar_McPrevMaint setPageHeader={setPageHeader} />
                  )}
                />

                <Route
                  exact
                  path="/v02/:urlCode/calibration/calibcalendar"
                  component={() => (
                    <Calendar_Calibration setPageHeader={setPageHeader} />
                  )}
                />
                <Route
                  exact
                  path="/v02/:urlCode/pms/task-calendar"
                  component={() => (
                    <TaskCalendar setPageHeader={setPageHeader} />
                  )}
                />
                <Route
                  exact
                  path="/v02/:urlCode/new-page"
                  component={() => (
                    <NewPage setPageHeader={setPageHeader} />
                  )}
                />
                <Route
                  exact
                  path="/v02/:urlCode/corporate-plant"
                  component={() => (
                    <CorporatePlant setPageHeader={setPageHeader} />
                  )}
                />
                <Route
                  exact
                  path="/v02/:urlCode/EnergyReport"
                  component={() => (
                    <EnergyReport setPageHeader={setPageHeader} />
                  )}
                />
                <Route
                  exact
                  path="/v02/:urlCode/create-audit"
                  component={() => (
                    <CreateUpdateAuditPage setPageHeader={setPageHeader} />
                  )}
                />
                <Route
                  exact
                  path="/v02/:urlCode/audit-list"
                  component={() => <ListAudit setPageHeader={setPageHeader} />}
                />
                <Route
                  exact
                  path="/v02/:urlCode/auditreport/:auditId"
                  component={() => (
                    <ViewReportAudit setPageHeader={setPageHeader} />
                  )}
                />


                <Route
                  exact
                  path="/v02/:urlCode/dashboard"
                  component={() => (
                    <ManagerDashboard setPageHeader={setPageHeader} />
                  )}
                />

                <Route
                  exact
                  path="/v02/:urlCode/spc"
                  component={() => <Spc setPageHeader={setPageHeader} />}
                />



                <Route
                  exact
                  path="/goldentunnel"
                  component={() => (
                    <GoldenTunnel setPageHeader={setPageHeader} />
                  )}
                />


                <Route
                  exact
                  path="/v02/:urlCode/dashboard/multiparam"
                  component={() => (
                    <ManagerDashboardMultiParam setPageHeader={setPageHeader} />
                  )}
                />


                <Route
                  exact
                  path="/v02/:urlCode/fourm/creategen4m"
                  component={() => <CreateGen4m setPageHeader={setPageHeader} />}
                />

                <Route
                  exact
                  path="/v02/:urlCode/gil/creategil4mnew"
                  component={() => <CreateNewGil4M setPageHeader={setPageHeader} />}
                />
                <Route
                  exact
                  path="/v02/:urlCode/gil/creategilSupplier4m"
                  component={() => <CreateGilSupplier4M setPageHeader={setPageHeader} />}
                />
                <Route
                  exact
                  path="/v02/:urlCode/gil/creategilsreanew"
                  component={() => <CreateGilSreaNew setPageHeader={setPageHeader} />}
                />

                <Route
                  exact
                  path="/v02/:urlCode/gil/creategil4m"
                  component={() => <CreateGil4M setPageHeader={setPageHeader} />}
                />

                <Route
                  exact
                  path="/v02/:urlCode/uploadfiles"
                  component={() => <UploadFile setPageHeader={setPageHeader} />}
                />

                <Route
                  exact
                  path="/v02/:urlCode/resetpassword"
                  component={() => (
                    <PasswordReset setPageHeader={setPageHeader} />
                  )}
                />

                <Route
                  exact
                  path="/v02/:urlCode/charts"
                  component={() => <Charts setPageHeader={setPageHeader} />}
                />


                <Route
                  exact
                  path="/v02/:urlCode/route-slideshow"
                  component={() => (
                    <RouteSlideShow
                      setPageHeader={setPageHeader}
                      pageName="Route Slide Show"
                      urlEndpoint="/textapi"
                      urlData={{ dn: "Kamishibai" }}
                      urlMethod="GET"
                    />
                  )}
                />
                <Route
                  exact
                  path="/v02/:urlCode/img-slideshow"
                  component={() => (
                    <ImageSlideShow
                      setPageHeader={setPageHeader}
                      pageName="Image Slide Show"
                      urlEndpoint="/textapi"
                      urlData={{ dn: "Kamishibai" }}
                      urlMethod="GET"
                    />
                  )}
                />
                <Route
                  exact
                  path="/v02/:urlCode/img-slider"
                  component={() => (
                    <ImageSlideShow
                      src={"dynamic"}
                      setPageHeader={setPageHeader}
                      pageName="Image Slider"
                      api={"/textapi"}
                      params={{ dn: 'ImageCorousel' }}
                      urlMethod="GET"
                    />
                  )}
                />
                <Route
                  exact
                  path="/v02/:urlCode/vehicle-tracker"
                  component={() => (
                    <VehicleTracker
                      setPageHeader={setPageHeader}
                      pageName="Image Slider"
                      urlData={{ dn: "Kamishibai" }}
                      urlMethod="GET"
                    />
                  )}
                />



                <Route
                  exact
                  path="/v02/:urlCode/production-slot-report-test"
                  component={() => (
                    <ProductionReport
                      setPageHeader={setPageHeader}
                      pageName="Production Report"
                    />
                  )}
                />

                <Route
                  exact
                  path="/v02/:urlCode/folder-tree"
                  component={() => (
                    <FolderTree />
                  )}
                />

                <Route
                  exact
                  path="/v02/:urlCode/zenform-builder"
                  component={() => (
                    <ZenFormBuilder
                      // editSingleColumn={true}
                      // zenTable={true}
                      setPageHeader={setPageHeader}
                      pageName="ZenForm"
                      urlEndpoint="/miscellaneous/pageconfig"
                    />
                  )}
                />
                <Route
                  exact
                  path="/v02/:urlCode/query-builder"
                  component={() => (
                    <QueryBuilder
                      // editSingleColumn={true}
                      // zenTable={true}
                      setPageHeader={setPageHeader}
                      pageName="ZenForm"
                      urlEndpoint="/miscellaneous/pageconfig"
                    />
                  )}
                />
                <Route
                  exact
                  path="/v02/:urlCode/chart-builder"
                  component={() => (
                    <ChartBuilder
                      // editSingleColumn={true}
                      // zenTable={true}
                      setPageHeader={setPageHeader}
                      pageName="ZenForm"
                      urlEndpoint="/miscellaneous/pageconfig"
                    />
                  )}
                />
                <Route
                  exact
                  path="/v02/:urlCode/stable-builder"
                  component={() => (
                    <StableBuilder
                      // editSingleColumn={true}
                      // zenTable={true}
                      setPageHeader={setPageHeader}
                      pageName="ZenForm"
                      urlEndpoint="/miscellaneous/pageconfig"
                    />
                  )}
                />
                <Route
                  exact
                  path="/v02/:urlCode/sparkTable-builder"
                  component={() => (
                    <SparkTableBuilder
                      // editSingleColumn={true}
                      // zenTable={true}
                      setPageHeader={setPageHeader}
                      pageName="ZenForm"
                      urlEndpoint="/miscellaneous/pageconfig"
                    />
                  )}
                />
                <Route
                  exact
                  path="/v02/:urlCode/stable-preview"
                  component={() => (
                    <StablePreview
                      // editSingleColumn={true}
                      // zenTable={true}
                      setPageHeader={setPageHeader}
                      pageName="ZenForm"
                    />
                  )}
                />

                <Route
                  exact
                  path="/v02/:urlCode/tree-data"
                  component={() => <TreeComponent />}
                />

                <Route
                  exact
                  path="/v02/:urlCode/phantreeprime"
                  component={() => (
                    <PhantreePrime
                      setPageHeader={setPageHeader}
                      pageName="Phantree Prime"
                      urlEndpoint="/miscellaneous/pageconfig"
                      urlData={{ dictName: "FormatPhantreeTemplateQuery1" }}
                    />
                  )}
                />

                <Route
                  exact
                  path="/v02/:urlCode/reportree/:typ/:subtyp"
                  component={() => (
                    <ReportTree
                      setPageHeader={setPageHeader}
                      pageName="Report Tree"
                      urlEndpoint="/miscellaneous/pageconfig"
                    />
                  )}
                />
                <Route
                  exact
                  path="/v02/:urlCode/video-player"
                  component={() => (
                    <VideoPlayer
                      setPageHeader={setPageHeader}
                    />
                  )}
                />

                {/* <Route
                  exact
                  path="/v02/:urlCode/sn"
                  component={() => (
                    <StAddNew
                      // editSingleColumn={true}
                      // zenTable={true}
                      setPageHeader={setPageHeader}
                      pageName="StAddNew"
                      urlEndpoint="/miscellaneous/pageconfig"
                    />
                  )}
                />*/}
                <Route 
                  exact
                  path="/v02/:urlCode/api-test"
                  component={() => (
                    <ApiTest
                      setPageHeader={setPageHeader}
                    />
                  )}
                />
                {/* <Route
                  exact
                  path="/v02/:urlCode/pp"
                  component={() => (
                    <PhantomPrime
                      setPageHeader={setPageHeader}
                      pageName="PhantomPrime"
                      urlEndpoint="/miscellaneous/pageconfig"
                    />
                  )}
                /> */}
                {/* <Route
                  exact
                  path="/v02/:urlCode/dc"
                  component={() => <DynamicZenChart setPageHeader={setPageHeader} />}
                /> */}
                <Route
                  exact
                  path="/v02/:urlCode/rfid"
                  component={() => <RFIDModal setPageHeader={setPageHeader} />}
                />
                {/* <Route
                  exact
                  path="/v02/:urlCode/zf/:typ/:subtyp"
                  component={() => (
                    <ZenForm
                      setPageHeader={setPageHeader}
                      pageName="ZenForm"
                      urlEndpoint="/miscellaneous/pageconfig"

                    />
                  )}
                /> */}
                {/* <Route
                  exact
                  path="/v02/:urlCode/qcf/:typ/:subtyp"
                  component={() => (
                    <ZenForm
                      setPageHeader={setPageHeader}
                      pageName="ZenForm"
                      urlEndpoint="/sparktable/miscellaneouspageconfig"
                    />
                  )}
                /> */}
                <Route
                  exact
                  path="/v02/:urlCode/configjsoneditor"
                  component={() => (
                    <PhantomPrime
                      dictName="ConfigJsonEditorQuery"
                      showJSONeditor={true}
                      // editSingleColumn={true}
                      // zenTable={true}
                      setPageHeader={setPageHeader}
                      pageName="PhantomPrime"
                      urlEndpoint="/miscellaneous/pageconfig"
                    />
                  )}
                />
                <Route
                  exact
                  path="/v02/:urlCode/zen-json-editor"
                  component={() => (
                    <ZenJSONEditor
                      // editSingleColumn={true}
                      // zenTable={true}
                      setPageHeader={setPageHeader}
                      pageName="PhantomPrime"
                      urlEndpoint="/miscellaneous/pageconfig"
                    />
                  )}
                />

                <Route
                  exact
                  path="/v02/:urlCode/gilsreareqform/:typ/:subtyp"
                  component={() => (
                    <ZenForm
                      // editSingleColumn={true}
                      // zenTable={true}
                      setPageHeader={setPageHeader}
                      pageName="Srea Request Form"
                      urlEndpoint="/gil/sreareqform"

                    />
                  )}
                />

                <Route
                  exact
                  path="/v02/:urlCode/gilviolationintimation/:typ/:subtyp"
                  component={() => (
                    <ZenForm
                      // editSingleColumn={true}
                      // zenTable={true}
                      setPageHeader={setPageHeader}
                      pageName="Violation Intimation"
                      urlEndpoint="/gil/violationreq"

                    />
                  )}
                />

                <Route
                  exact
                  path="/v02/:urlCode/sfreqform/:typ/:subtyp"
                  component={() => (
                    <ZenForm
                      // editSingleColumn={true}
                      // zenTable={true}
                      setPageHeader={setPageHeader}
                      pageName="Sun Flag"
                      urlEndpoint="/sfnewfourm"

                    />
                  )}
                />

                <Route
                  exact
                  path="/v02/:urlCode/gil/supplierreq/:typ/:subtyp"
                  component={() => (
                    <ZenForm
                      // editSingleColumn={true}
                      // zenTable={true}
                      setPageHeader={setPageHeader}
                      pageName="Gil Supplier Request"
                      urlEndpoint="/gil/supplierreq"

                    />
                  )}
                />

                <Route
                  exact
                  path="/v02/:urlCode/gilsupplierreqaddnew/:typ/:subtyp"
                  component={() => (
                    <ZenForm
                      // editSingleColumn={true}
                      // zenTable={true}
                      setPageHeader={setPageHeader}
                      pageName="Gil Supplier Request"
                      urlEndpoint="/gil/supplierreq"

                    />
                  )}
                />

                <Route
                  exact
                  path="/v02/:urlCode/qc/customercomplaint/:typ/:subtyp"
                  component={() => (
                    <ZenForm
                      editSingleColumn={true}
                      zenTable={true}
                      setPageHeader={setPageHeader}
                      pageName="Customer Complaint"
                      urlEndpoint="/customercomplaintsingle"
                      dictName="CustomerComplaintZenForm"
                    />
                  )}
                />


                <Route
                  exact
                  path="/v02/:urlCode/yipl/customercomplaint/:typ/:subtyp"
                  component={() => (
                    <ZenForm
                      editSingleColumn={true}
                      zenTable={true}
                      setPageHeader={setPageHeader}
                      pageName="Customer Complaint"
                      urlEndpoint="/customercomplaintsingle"
                      dictName="CustomerComplaintYipl"
                    />
                  )}
                />

                <Route
                  exact
                  path="/v02/:urlCode/semi"
                  component={() => (
                    <SemiCircleParent setPageHeader={setPageHeader} />
                  )}
                />

                <Route
                  exact
                  path="/v02/:urlCode/liraadmin"
                  component={() => (
                    <VersionPage setPageHeader={setPageHeader} />
                  )}
                />

                <Route
                  exact
                  path="/v02/:urlCode/lineperformancemobile"
                  component={() => (
                    <LinePerformancemob setPageHeader={setPageHeader} />
                  )}
                />

                <Route
                  exact
                  path="/v02/:urlCode/lineperformancelineleaders"
                  component={() => (
                    <LinePerformanceLineLeaders setPageHeader={setPageHeader} />
                  )}
                />

                <Route
                  exact
                  path="/v02/:urlCode/sbplan/upload"
                  component={() => <UploadPlan setPageHeader={setPageHeader} />}
                />

                <Route
                  exact
                  path="/v02/:urlCode/livoecn/upload"
                  component={() => (
                    <UploadLivoECN setPageHeader={setPageHeader} />
                  )}
                />

                <Route
                  exact
                  path="/v02/:urlCode/charts"
                  component={() => (
                    <DrillDownPieChart setPageHeader={setPageHeader} />
                  )}
                />

                <Route
                  exact
                  path="/v02/:urlCode/calendar"
                  component={() => (
                    <CalendarPage setPageHeader={setPageHeader} />
                  )}
                />


                <Route
                  exact
                  path="/v02/:urlCode/calendar/day"
                  component={() => (
                    <Calendar_Day setPageHeader={setPageHeader} />
                  )}
                />
                <Route
                  exact
                  path="/v02/:urlCode/calendar/time"
                  component={() => (
                    <CalenderTime setPageHeader={setPageHeader} />
                  )}
                />

                <Route
                  exact
                  path="/v02/:urlCode/gantt"
                  component={() => (
                    <ParentGanttChart setPageHeader={setPageHeader} />
                  )}
                />

                <Route
                  exact
                  path="/v02/:urlCode/lineattendance"
                  component={() => (
                    <LineAccessDropDown setPageHeader={setPageHeader} />
                  )}
                />
                <Route path="/v02/:urlCode/login" component={SignIn} />

                {
                  allRoutes.map((route, idx) => (
                    <React.Fragment key={idx}>
                      <Route
                        path={route.route}
                        component={() => route.component({ setPageHeader })}
                      />
                    </React.Fragment>
                  ))
                }
              </ScrollToTop>
            </Dashboard>
            {/* <Route
              component={() => (
                <PageNotFound setPageHeader={"Page Not Found!"} />
              )}
            /> */}
          </Switch>
        </Router>
      )}
    </>
    //   )}
    // </>
  );
}

export default React.memo(ModRouter, (prev, next) => {
  return false;
});
